export const colors = {
  white: "#fff",
  brandDark: "#001B20",
  buttonColor: "#7BC792",
  bgColor: "#00414C",
  gray: "#F4F4F4",
  textColor: "#262626",
  lightButtonColor: "#E6ECED",
  cardBgColor: "#F5F7F6",
  lightTextColor: "#525252",
  navBgColor: "#336770",
  menuBgColor: "#D6EEDD",
  whiteColor: "#FFFFFF",
  buttonBorder: "#8AA8AD",
  lightTextColor2: "#8D8D8D",
  borderColor: "#C6C6C6",
  actionRequired: "#AB0717",
  underReview: "#6B5A00",
  actionRequiredBgColor: "#FFEBEB",
  underReviewBgColor: "#FFFBE5",
  tableColor: "#E0E0E0",
  tableTextColor: "#6B7280",
  tableborderColor: "#1C1B1F",
  tablebuttonColor: "#BDBDBD",
  tablepageBgColor: "#F5F5F5",
  paginationTextColor: "#6F6F6F",
};
